import React from 'react';

const EmptyState = () => {
  return (
    <div className='text-center py-10'>
      <div className='inline-flex items-center justify-center'>
        <svg className='w-12 h-12 text-slate-400' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4'
          />
        </svg>
      </div>
      <h3 className='mt-2 font-medium text-slate-800'>Todo al día</h3>
      <p className='mt-1 text-sm text-slate-500'>No hay tareas pendientes en este momento.</p>
    </div>
  );
};

export default EmptyState;
